import React from 'react';
import Hero from './Hero';
import About from './About';
import LocationFeatures from './LocationFeatures';
import OperatingStandards from './OperatingStandards';
import Services from './Services';
import CommunityAssessment from './CommunityAssessment';
import Partners from './Partners';
import Contact from './Contact';
import Booking from './Booking';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <LocationFeatures />
      <OperatingStandards />
      <Services />
      <CommunityAssessment />
      <Partners />
      <Contact />
      <Booking />
    </>
  );
};

export default Home;